import { render, staticRenderFns } from "./campaignHeader.vue?vue&type=template&id=0f4e7ede&"
import script from "./campaignHeader.vue?vue&type=script&lang=js&"
export * from "./campaignHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports